export default __webpack_public_path__ + "static/media/real_estate_web-xs@1x.54cc53ee.webp";